document.addEventListener('DOMContentLoaded', function () {
  const player = document.querySelector('.wp-block-video video');

  if (player) {
    document.addEventListener('click', function (event) {
      if (event.target.matches('.wp-block-video video')) {
        const videoContainer = event.target.parentElement;
        videoContainer.classList.add('video-playing');
        const video = event.target;

        if (!video.paused) {
          video.pause();
        } else {
          video.play();
        }

        event.preventDefault();
      }
    });
  }
});

//play/pause home header video
document.addEventListener('DOMContentLoaded', function () {
  const headerVideo = document.querySelector('.page-header__home__video');
  const playPauseButton = document.querySelector('.video-button');

  if (headerVideo && playPauseButton) {
    // Play/pause video on click on play/pause button
    playPauseButton.addEventListener('click', function () {
      if (!headerVideo.paused) {
        headerVideo.pause();
        playPauseButton.classList.toggle('video-button--play');
        playPauseButton.classList.toggle('video-button--pause');
      } else {
        headerVideo.play();
        playPauseButton.classList.toggle('video-button--pause');
        playPauseButton.classList.toggle('video-button--play');
      }
    });
  }
});

//play/pause home header YOUTUBE video
document.addEventListener('DOMContentLoaded', function () {
  const youtubePlayer = document.querySelector('.page-header__home__youtube');
  const playPauseButton = document.querySelector('.video-button');

  if (youtubePlayer && playPauseButton) {
    // Play/pause video on click on play/pause button
    playPauseButton.addEventListener('click', function () {
      if (playPauseButton.classList.contains('video-button--pause')) {
        youtubePlayer.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          '*'
        );
        playPauseButton.classList.toggle('video-button--pause');
        playPauseButton.classList.toggle('video-button--play');
      } else {
        youtubePlayer.contentWindow.postMessage(
          '{"event":"command","func":"playVideo","args":""}',
          '*'
        );
        playPauseButton.classList.toggle('video-button--play');
        playPauseButton.classList.toggle('video-button--pause');
      }
    });
  }
});

// Fonction pour activer/désactiver les animations
function toggleVideoPlay() {
  const headerVideo = document.querySelector('.page-header__home__video');
  const playPauseButton = document.querySelector('.video-button');
  const youtubePlayer = document.querySelector('.page-header__home__youtube');
  if (document.documentElement.classList.contains('no-animation')) {
    if (headerVideo) {
      headerVideo.pause();
      playPauseButton.classList.remove('video-button--pause');
      playPauseButton.classList.add('video-button--play');
    } else if (youtubePlayer) {
      youtubePlayer.contentWindow.postMessage(
        '{"event":"command","func":"pauseVideo","args":""}',
        '*'
      );
      playPauseButton.classList.remove('video-button--pause');
      playPauseButton.classList.add('video-button--play');
    }
  } else if (!document.documentElement.classList.contains('no-animation')) {
    if (headerVideo) {
      headerVideo.play();
      playPauseButton.classList.remove('video-button--play');
      playPauseButton.classList.add('video-button--pause');
    } else if (youtubePlayer) {
      youtubePlayer.contentWindow.postMessage(
        '{"event":"command","func":"playVideo","args":""}',
        '*'
      );
      playPauseButton.classList.remove('video-button--play');
      playPauseButton.classList.add('video-button--pause');
    }
  }
}
// Vérifier initialement si la classe 'no-animation' est présente
toggleVideoPlay();
// Observer les changements de classes sur la balise html
const observer = new MutationObserver(() => {
  toggleVideoPlay();
});
// Configurer l'observateur pour surveiller les attributs
observer.observe(document.documentElement, {
  attributes: true,
  attributeFilter: ['class'],
});
